import $ from 'jquery';
import {Component} from '../../../component';
export class Global extends Component {

    /**
     * Constructor
     */
    constructor(context) {
        super(context);

        $.scroll_to_notices = this.scrollToNotices.bind(this);
    }

    /**
     * setup
     */
    setup() {
        // console.log(el, 'scrollToNotices');
    }

    /**
     * scrollToNotices
     */
    scrollToNotices(el) {
        console.log(el, 'scrollToNotices');
    }
}
